import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { LandingModelService } from 'projects/common/services/landingModel.service';

export interface GridOptions {
  columns: number
  rows: number
  gap: number
  separator?: boolean
  grid_template_areas?: string[]
}


@Component({
  selector: 'grid',
  template: `
        <div 
          [class]="gridCssClasses"
          [ngStyle]="styles">
            <ng-content></ng-content>
        </div>
    `,
  styleUrls: ['./grid.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class GridComponent implements OnInit {
  @Input() options: GridOptions;

  @Input() responsiveGrid: boolean = false;

  public gridCssClasses: string = 'grid-container';
  public styles: { [key: string]: string } = {};

  constructor(private landingModelService: LandingModelService) { }

  ngOnInit(): void {
    this.styles['grid-gap'] = this.options.gap + 'px';
    this.gridCssClasses += this.responsiveGrid ? ' -responsive' : '';
    this.gridCssClasses += this.options.grid_template_areas != null ? ' -area' : '';
    this.gridCssClasses += this.landingModelService.getLandingModel().webview ? ' -webview' : ' -no-webview';
    this.gridCssClasses += this.options.separator ? ' -with-separator' : '';

    if (this.options.grid_template_areas){

      this.styles['display'] = 'grid';
      this.styles['grid-template-areas'] = this.options.grid_template_areas.map(rowConfig => `"${rowConfig}"`).join(' ');
    } else {

      this.gridCssClasses += ` grid-columns-${this.options.columns} grid-rows-${this.options.rows}`;
    }
   }

}
